import { message, Select } from 'antd';
import React from 'react';
import BookingApi from '../../functions/api/booking/BookingApi';
import { normalizeOptions } from './form/CustomSelect';

export default class LevelBooking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      levels: [],
    };
  }

  static getDerivedStateFromProps(props) {
    const { levels } = props;
    if (levels.length > 0) {
      return { levels };
    }

    return null;
  }

  onChange = async (levelId) => {
    const booking = this.props.row;

    const result = await BookingApi.updateLevel(
      this.props.row.book_id,
      levelId
    );
    if (!result || result.code !== 'success') {
      message.error(result.message ?? 'Lỗi lưu booking');
      return;
    }

    message.success(`Đã lưu level cho booking ${booking.book_code}`);

    this.props.onChange({ ...booking, book_stt_id: levelId });

    if (levelId === 9) {
      //Nếu L8 và chưa forward
      if (!booking['book_time_send_part']) {
        await BookingApi.forwardBooking(booking.book_id);
      }
      await BookingApi.acceptBooking(booking.book_id);
    }
  };

  render() {
    const { levels } = this.state;

    if (levels.length === 0) {
      return null;
    }

    return (
      <Select
        defaultValue={this.props.row.book_stt_id}
        options={normalizeOptions('book_stt_name', 'book_stt_id', levels)}
        onChange={this.onChange}
      />
    );
  }
}
